export const formateTimeZone = (time: Date) => {
    if (time !== null) {
        const timestamp: Date = new Date(time);
        var hours = timestamp.getHours().toString().padStart(2, '0');
        var minutes = timestamp.getMinutes().toString().padStart(2, '0');
        var seconds = timestamp.getSeconds().toString().padStart(2, '0');
        var newTimeFormate = hours + ":" + minutes + ":" + seconds
        return newTimeFormate
    }
}